import "./processing.scss";
import { Aperture, Loader } from "react-feather";
type processingProps = {
    children: any;
};

const Processing = (props: processingProps) => {
    return (
        <div className="processinContainer">
            <div className="iconP">
                <Aperture className="spLoader"></Aperture>
            </div>

            <div className="procText">{props.children}</div>
        </div>
    );
};

export default Processing;
